import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import {
  DetailsConstructionResponse,
  DetailsConstructionTransfer,
  UpdateConstructionRequest,
} from '../models/detailsConstruction';

/**
 * <p>
 * API endpoints that cover all details construction related CRUD calls
 */
export const detailsConstructionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    constructionTransfer: builder.mutation<void, DetailsConstructionTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-construction/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsConstruction', 'SearchDetails'],
    }),
    searchDetailsConstruction: builder.query<DetailsConstructionResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `/report/details-construction/search?searchTerm=${params.searchTerm}&projectCode=${params.project}&period=${params.period}&subgroup=${params.subGroup}&`,
        ),
      }),
      providesTags: ['SearchDetailsConstruction', 'SearchEquipment', 'SearchDetails'],
    }),
    UnitConstruction: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-construction/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsConstruction'],
    }),
    undoUnionConstruction: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-construction/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsConstruction'],
    }),
    updateDetailsConstruction: builder.mutation<void, UpdateConstructionRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-construction/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsConstruction'],
    }),
  }),
});

export const {
  useConstructionTransferMutation,
  useSearchDetailsConstructionQuery,
  useUnitConstructionMutation,
  useUndoUnionConstructionMutation,
  useUpdateDetailsConstructionMutation,
} = detailsConstructionApi;
